module.exports = __webpack_public_path__ + "static/projekt-etykiety-muszyna-e715e098576ab1805f7c319d91f94a51.jpg";